
import React, { Component } from "react";
import "./assetsubtitlelist.css";

class AssetSubtitleList extends Component 
{
    handleAdd = (index) => {
        if (this.props.onAdd) {
            this.props.onAdd(index);
        }
    };

    render() {
        const { assets = [] } = this.props;

        return (
            <div className="asset-list">

                {/* Barre de titre */}
                <div className="asset-list-header">
                    <div className="asset-col-number">Asset</div>
                    <div className="asset-col-type">Type</div>
                    <div className="asset-col-title">Titre</div>
                    <div className="asset-col-count">ST</div>
                    <div className="asset-col-button"></div>
                </div>

                {/* Liste */}
                <div className="asset-list-content">
                    {assets.map((asset, index) => (
                        <div
                            className={
                                "asset-list-row " +
                                (index % 2 === 1 ? "asset-list-row-alt" : "")
                            }
                            key={index}
                        >
                            <div className="asset-col-number">
                                {asset.asid}
                            </div>

                            <div className="asset-col-type">
                                {asset.astype === 4 ? "Original" : "Modifié"}
                            </div>

                            <div className="asset-col-title">
                                {asset.astitle}
                            </div>

                            <div className="asset-col-count">
                                {asset.assubtitlecount}
                            </div>

                            <div className="asset-col-button">
                                <button
                                    className="asset-add-button"
                                    onClick={() => this.handleAdd(index)}
                                >
                                    +
                                </button>
                            </div>
                        </div>
                    ))}
                </div>

            </div>
        );
    }
}

export default AssetSubtitleList;
